import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Endpoint } from '@/Config/api/endpoint';
import { ConversationAnalysisAlertsApi } from '@/Domain/api/Conversation/ConversationAnalysisAlerts.api';
import { AlertDto } from '@/Domain/api/Conversation/dto/Alert.dto';

export const useConversationAnalysisAlertUpdate = () => {
  const { t } = useTranslation('insights_page');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [`${Endpoint.conversationAnalysisAlerts.update}-update`],
    mutationFn: (alert: AlertDto) => ConversationAnalysisAlertsApi.update(alert),
    onSuccess: (data) => {
      queryClient.setQueryData(
        [`${Endpoint.conversationAnalysisAlerts.list}-list`],
        (prev: AlertDto[] | undefined) =>
          (prev ?? []).map((item) => (item.id === data.id ? { ...item, ...data } : item)),
      );
      toast.success(t('toast.update_alert.success'));
    },
    onError: (error: AxiosError) => {
      toast.error(
        get(error, 'response.data.errors.root[0].message') || t('toast.update_alert.error'),
      );
    },
  });

  const handleUpdateAlert = (alert: AlertDto) => mutation.mutateAsync(alert);

  return { handleUpdateAlert, isPending: mutation.isPending };
};
